import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from 'react';
import { runtimeConfig } from '../utils/runtimeConfig';
const NetworkContext = createContext(null);
export const NetworkProvider = ({ children }) => {
    // Get default from runtime config, fallback to mainnet
    const getDefaultNetwork = () => {
        const configNetwork = runtimeConfig.getDefaultNetwork();
        if (configNetwork === 'mainnet' || configNetwork === 'testnet' || configNetwork === 'devnet') {
            return configNetwork;
        }
        return 'mainnet'; // Default to mainnet
    };
    const [network, setNetworkState] = useState(getDefaultNetwork());
    const setNetwork = useCallback((newNetwork) => {
        setNetworkState(newNetwork);
        console.log(`🔄 Network switched to: ${newNetwork}`);
    }, []);
    const availableNetworks = ['mainnet', 'testnet', 'devnet'];
    const contextValue = {
        network,
        setNetwork,
        availableNetworks,
    };
    return _jsx(NetworkContext.Provider, { value: contextValue, children: children });
};
export const useNetwork = () => {
    const context = useContext(NetworkContext);
    if (!context) {
        throw new Error('useNetwork must be used within a NetworkProvider');
    }
    return context;
};
// Helper hook to get just the network string (for backward compatibility)
export const useNetworkString = () => {
    const { network } = useNetwork();
    return network;
};
